// TODO: should be marked as server-only
// import 'server-only';
import { Locale } from '@headless-workspace/config';
import { Result } from '@headless-workspace/core-domain';
import { EcomConfigKeys, getCachedEcomConfigByKey, LoyaltyConfigsValue } from '../config';

export const getCachedLoyalty = async (locale: Locale) =>
    getCachedEcomConfigByKey(locale, EcomConfigKeys.LoyaltyConfig);
